import React from "react"
import { GatsbyImage } from "gatsby-plugin-image"

const FeaturedPromotions = ({props}) => {
  return(
    <section className="section">
      <div className="container">
        <div className="columns m-0 py-5">
          {props.map(el => {
            return (
              <div className="column" key={el.id}>
                <GatsbyImage image={el.image.gatsbyImageData} alt={el.imageAltText} />
                <h2 className="is-size-4 is-size-5-mobile has-text-centered has-text-danger is-uppercase">{el.heading}</h2>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default FeaturedPromotions